import axios from 'axios';
import authHeader from './auth-header';

import store from '@/store'

const API_URL = process.env.VUE_APP_BACKEND_API_BASE_URL;

class LandlordService {
  getLandlordById(landlord_id){
    return axios.get(API_URL + 'landlord/' + landlord_id, { headers: authHeader() })
    .then(response => {
      return response.data; 
    },error => {
      if(error.response.status == 401){
        store.dispatch('auth/logout');
      }
    });
  }

  getLandlordAllDataById(landlord_id){
    return axios.get(API_URL + 'landlord/all_data/' + landlord_id, { headers: authHeader() })
    .then(response => {
      return response.data; 
    },
    error => {
      if(error.response.status == 401){
        store.dispatch('auth/logout');
      }
    });
  }

  updateLandlordById(landlord_id, landlord_model){
    return axios.patch(API_URL + 'landlord/' + landlord_id, landlord_model, { headers: authHeader() })
    .then(response => {
      return response.data; 
    });
  }

  getLandlordAllModules(landlordId){
    return axios.get(API_URL + 'landlord/'+ landlordId+'/all_modules', { headers: authHeader() })
    .then(response => {
      return response.data; 
    },
    error => {
      if(error.response.status == 401){
        store.dispatch('auth/logout');
      }
    });
    
  }
}

export default new LandlordService();